module.exports = __webpack_public_path__ + "img/d201209-4.73e30a65.jpg";